<div class="no-data row">
    <img src="/images/alert.png">
    <br>
    <p>{{$ctrl.msg}}</p>

</div>